<mat-vertical-stepper orientation="vertical" #stepper>
  <div>
    <mat-step>
      <ng-template matStepLabel>{{ res.get('SelectWorkTemplate') }}</ng-template>

      <div *ngIf="isLoadingWorkTypes" class="loading-container">
        <mat-spinner diameter="30"></mat-spinner>
        <div style="margin-top: 8px">
          {{ res.get('LoadingWorkTemplates') || 'Loading...' }}
        </div>
      </div>

      <ng-container *ngIf="!isLoadingWorkTypes">
        <abc-list
          #list
          [dataSource]="workTypeData"
          height="120"
          [selectedItemKeys]="[]"
          [showSelectionControls]="false"
          selectionMode="single"
          (onSelectionChanged)="listSelectionChanged($event)"
          [noDataText]="res.get('NoDataTextArbeitsTemplate')"
        >
          <div *dxTemplate="let item of 'item'">
            <div>{{ item.Description }}</div>
          </div>
        </abc-list>
      </ng-container>

      <br />
      <hr />
      <div fxLayout=" row" style="float: right">
        <div fxFlex="30">
          <button mat-button (click)="moveStep(stepper)" [disabled]="disableDataContinueButton">
            {{ res.get('ButtonTextContinue') }}
          </button>
        </div>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ res.get('StepperTextWorksGeneration') }}</ng-template>
      <br />
      <div>
        <p>{{ res.get('StepperTextWorksCanBeGenerated') }}</p>
        <br />
        <mat-checkbox
          class="checkbox"
          [checked]="editResultsImmediatly"
          (change)="toggleEditResult(editResultsImmediatly)"
          >{{ res.get('StepperTextCreateWorkResults') }}
        </mat-checkbox>
        <br />
        @if (display) {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
        <br />
        <hr />
        <div class="step-buttons">
          <button mat-button class="back-button" matStepperPrevious [disabled]="buttonStatus">
            {{ res.get('ButtonTextBack') }}
          </button>
          <button mat-button (click)="execute()" [disabled]="disableDataContinueButton">
            <span>{{ res.get('ButtonTextStartExecution') }}</span>
          </button>
        </div>
      </div>
    </mat-step>
  </div>
</mat-vertical-stepper>
